import { API_URLS } from "../../Configs/apiUrls";
import axiosInstance from "../../Configs/axios";


export const PostLocation = (redBody) => {
    try {
        const response = axiosInstance.post(API_URLS.location, redBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};



export const GetLocation = (redBody) => {
    try {
        const response = axiosInstance.get(API_URLS.location, { params: redBody });
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};